import { render, staticRenderFns } from "./EmojiIcon.vue?vue&type=template&id=3853d32a"
import script from "./EmojiIcon.vue?vue&type=script&lang=js"
export * from "./EmojiIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports